<div class="pro-widget">
  <div class="corr-options">
    <div id="tour-metric-selector" class="pro-widget__title toggle-pro-list corr-options__option"
      (click)="metricListOpen = !metricListOpen" [ngClass]="{ 'toggle-pro-list--open': metricListOpen }">
      <div class="pro-widget__title-text"><span>Metric:</span> {{ metric()?.metricTitle }}</div>
      @if (!isPrinting()) {
      <svg class="icon pro-widget__title-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
        <path
          d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z" />
      </svg>
      }
    </div>
  </div>
  <div class="pro-widget__content">
    <div class="corr">
      <div class="corr__chart">
        <!-- Chart Container -->
        <ngx-datatable class="material fullscreen" [rows]="tableRows" [columns]="columns" [headerHeight]="50"
          [rowHeight]="'auto'" [limit]="20" [loadingIndicator]="isLoading"
          [sorts]="[{ prop: sortColumn, dir: sortDir }]" (sort)="onSort($event)">
          <!-- Default sorting -->>

          <ngx-datatable-column name="Rate">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.rate }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Lag">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.lag }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="R2">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div [style.background-color]="getHeatmapColor(row.r2)" class="heatmap-cell">
                {{ row.r2 }}
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Beta">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.beta }}
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
        <app-chart-info-box [information]="information()"
          [dialogInformationId]="dialogInformationId()"></app-chart-info-box>
      </div>
      <div class="pro-list" [ngClass]="{ 'pro-list--open': metricListOpen }">
        <div class="pro-list__inner">
          <div class="pro-list__search">
            <svg class="icon pro-list__search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z" />
            </svg>
            <input [(ngModel)]="metricSearch" type="text" placeholder="Start typing to search" autocomplete="off"
              class="pro-list__search-input">
            <div (click)="clearMetricSearch()" class="pro-list__clear-search">Clear Search <svg
                class="icon pro-list__clear-search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path
                  d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
              </svg></div>
          </div>
          <ul class="pro-list__options">
            <li
              *ngFor="let group of (regressionMetrics() | filterRegressionMetric: metricSearch) | groupBy: 'categoryTitle'"
              class="pro-list__options-item"
              [ngClass]="{ 'pro-list__options-item--open': isMetricCategoryOpen(group.key) || metricSearch.length >= 3 || onlyOneCategory()}">
              @if(!onlyOneCategory()){
              <div (click)="toggleMetricCategory(group.key)" class="pro-list__options-title">{{ group.key
                }} <svg class="icon pro-list__options-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                  <path
                    d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z" />
                </svg></div>
              }
              <ul class="pro-list__options-sub">
                <li *ngFor="let metric of group.value" (click)="selectMetric(metric.metricId)"
                  class="pro-list__options-sub-item">{{ metric.metricTitle }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>